import { useEffect, useState } from 'react';

const useExternalScript = (appName, useRoomVOIntegration, roomVOIntegrationUrl, scriptId, head = true) => {
  const [state, setState] = useState(roomVOIntegrationUrl ? 'loading' : 'idle');
  useEffect(() => {
    if (!useRoomVOIntegration || !roomVOIntegrationUrl || !appName) {
      setState('idle');
      return;
    }
    let script = document.querySelector(`script[src="${roomVOIntegrationUrl}"]`);
    const handleScript = (event) => {
      setState(event.type === 'load' ? 'ready' : 'error');
    };
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.type = 'text/javascript';
      script.src = roomVOIntegrationUrl;
      if (head) {
        document.head.appendChild(script);
      } else {
        document.body.appendChild(script);
      }
      script.addEventListener('load', handleScript);
      script.addEventListener('error', handleScript);
    }
    script.addEventListener('load', handleScript);
    script.addEventListener('error', handleScript);
    // eslint-disable-next-line consistent-return
    return () => {
      script.removeEventListener('load', handleScript);
      script.removeEventListener('error', handleScript);
    };
  }, [useRoomVOIntegration, roomVOIntegrationUrl, head, scriptId, appName]);
  return state;
};
export default useExternalScript;